import React from 'react';

import { FormControl, Input, InputLabel } from '@mui/material';

import { ESTIMATE_VALUE } from '../../constants/LoansCalculator';

import './EstimateValueInput.css';

export const EstimateValueInput = ({ estimateValue, onEstimateValueChange }) => {
  return (
    <div className="loans-estimate-value-input-wrapper">
      <InputLabel
        sx={{
          fontWeight: 600,
          mt: 0,
          marginBottom: '5px',
          fontSize: '14px',
          color: 'black',
        }}
      >
        {ESTIMATE_VALUE}
      </InputLabel>
      <FormControl sx={{ m: 0, width: '100%' }}>
        <div className="loans-estimate-input-wrapper">
          <Input
            id="loans-estimate-value-input"
            sx={{ width: '100%' }}
            value={estimateValue || ''}
            placeholder={ESTIMATE_VALUE}
            autoComplete="off"
            onChange={(e) => {
              if (!isNaN(e.target.value)) {
                onEstimateValueChange(e.target.value);
              } else {
                onEstimateValueChange('');
              }
            }}
            disableUnderline
          ></Input>
        </div>
      </FormControl>
    </div>
  );
};
